import React, { createContext, useState, useContext, useEffect } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  // 从localStorage加载用户数据，如果没有则使用默认数据
  const loadUserFromStorage = () => {
    const savedUser = localStorage.getItem('blog_user');
    if (savedUser) {
      return JSON.parse(savedUser);
    }
    
    // 默认用户数据
    return {
      name: 'zxj',
      email: 'zxj@yand.com',
      position: '智克',
      interests: '智克',
      bio: '这个人很神秘，什么也没留下。',
      location: '中国',
      joinDate: '2023年1月',
      socialMedia: '微博个人信息',
      skills: ['React', 'TypeScript', 'Node.js', 'MongoDB', 'Docker', 'Git'],
      techStack: [
        { name: 'React', level: 85 },
        { name: 'TypeScript', level: 75 },
        { name: 'Node.js', level: 80 },
        { name: 'MongoDB', level: 70 },
        { name: 'Docker', level: 65 },
        { name: 'Git', level: 90 }
      ],
      avatar: '', // 头像URL或base64
      avatarColor: '#4a90e2' // 默认头像颜色
    };
  };

  const [user, setUser] = useState(loadUserFromStorage());
  const [isEditing, setIsEditing] = useState(false);

  // 当用户数据变化时保存到localStorage
  useEffect(() => {
    localStorage.setItem('blog_user', JSON.stringify(user));
  }, [user]);

  // 更新用户信息
  const updateUser = (updatedData) => {
    setUser(prevUser => ({
      ...prevUser,
      ...updatedData
    }));
  };

  // 更新技能栈
  const updateTechStack = (techStack) => {
    setUser(prevUser => ({
      ...prevUser,
      techStack
    }));
  };

  // 添加技能
  const addSkill = (skill) => {
    if (user.skills.includes(skill)) {
      return;
    }
    setUser(prevUser => ({
      ...prevUser,
      skills: [...prevUser.skills, skill]
    }));
  };

  // 删除技能
  const removeSkill = (skill) => {
    setUser(prevUser => ({
      ...prevUser,
      skills: prevUser.skills.filter(s => s !== skill)
    }));
  };

  // 更新头像
  const updateAvatar = (avatarData) => {
    setUser(prevUser => ({
      ...prevUser,
      ...avatarData
    }));
  };

  // 重置为默认数据
  const resetToDefault = () => {
    const defaultUser = {
      name: 'zxj',
      email: 'zxj@yand.com',
      position: '智克',
      interests: '智克',
      bio: '这个人很神秘，什么也没留下。',
      location: '中国',
      joinDate: '2023年1月',
      socialMedia: '微博个人信息',
      skills: ['React', 'TypeScript', 'Node.js', 'MongoDB', 'Docker', 'Git'],
      techStack: [
        { name: 'React', level: 85 },
        { name: 'TypeScript', level: 75 },
        { name: 'Node.js', level: 80 },
        { name: 'MongoDB', level: 70 },
        { name: 'Docker', level: 65 },
        { name: 'Git', level: 90 }
      ],
      avatar: '',
      avatarColor: '#4a90e2'
    };
    setUser(defaultUser);
    localStorage.setItem('blog_user', JSON.stringify(defaultUser));
  };

  return (
    <UserContext.Provider value={{
      user,
      isEditing,
      setIsEditing,
      updateUser,
      updateTechStack,
      addSkill,
      removeSkill,
      updateAvatar,
      resetToDefault
    }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within UserProvider');
  }
  return context;
};